<template>
  <div class="award-mask"></div>
  <div class="award-wrap">
    <p class="award-title">{{ $t("coverGiftTitle") }}</p>
    <div class="award-list">
      <div
        class="award-item"
        v-for="(item, index) in coverAwardList"
        :key="index"
      >
        <img class="award-pic" :src="item.url" alt="award-pic" />
        <div class="award-num" v-if="+item.count">X {{ item.count }}</div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

import { useStore } from "vuex";
const store = useStore();
const coverAwardList = computed(() => {
  return store.state.survey.coverAwardList;
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";

.award-mask {
  position: absolute;
  bottom: 0;
  left: 0;
  @include setBackground(100%, 363px, "award_mask.png");

}
.award-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  @include setBackground(100%, 175px, "award_list_bg.png");

}
.award-title {
  font-size: 25px;
  font-weight: 600;
  color: #fff;
  text-align: center;
  padding-top: 15px;
  margin-bottom: 35px;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

}
.award-list {
  display: flex;
  justify-content: center;
  align-items: center;

  .award-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    @include setBackground(121px, 88px, "award_bg.png");
    .award-pic {
      max-width: 70px;
    }
    .award-num {
      position: absolute;
      padding: 0 5px;
      right: 10px;
      bottom: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #fff;
      @include setBackground(auto, 20px, "award_num_bg.png");
      background-size: 100% 100%;
    }
  }
}
</style>
